import RevealController from "@stimulus-components/reveal"

const SESSION_KEY_PREFIX = "revealOpenState:"

export default class extends RevealController {
  static values = {
    showText: { type: String },
    hideText: { type: String }
  }

  connect() {
    super.connect()
    this.restoreOpenState()
    this.updateLinkText()
  }

  toggle(event) {
    super.toggle()
    this.saveOpenState()
    this.updateLinkText()
  }

  updateLinkText() {
    const button = this.element.querySelector('[data-action*="reveal#toggle"]')
    if (!button) return

    const hidden = this.itemTargets[0].classList.contains('hidden')

    if (hidden) {
      if (this.showTextValue) button.textContent = this.showTextValue
    } else {
      if (this.hideTextValue) button.textContent = this.hideTextValue
    }
  }

  saveOpenState() {
    // Use a unique key for each reveal element (by id or index fallback)
    const key = this.sessionKey()
    const open = !this.itemTargets[0].classList.contains('hidden')
    window.sessionStorage.setItem(key, JSON.stringify(open))
  }

  restoreOpenState() {
    const key = this.sessionKey()
    let data = window.sessionStorage.getItem(key)

    if (data !== null) {
      try {
        const open = JSON.parse(data)
        this.itemTargets[0].classList.toggle('hidden', !open)
      } catch {
        // ignore parse errors
      }
    }
  }

  sessionKey() {
    // Create a page-scoped key so the same reveal on different pages stores separate states.
    // Key format: PREFIX + encodeURIComponent(pathname) + ':' + (id or index)
    const pageKey = encodeURIComponent(window.location.pathname)
    const button_id = this.element.querySelector('[data-action*="reveal#toggle"]').id

    if (button_id) {
      return SESSION_KEY_PREFIX + ':' + button_id
    } else {
      // fallback: use index among all reveal-controller elements on the page
      const all = Array.from(document.querySelectorAll('[data-controller~="reveal"]'))
      const idx = all.indexOf(this.element)
      return SESSION_KEY_PREFIX + pageKey + ':' + idx
    }
  }
}
